import React, { Component } from 'react';
import { connect } from 'react-redux';

import MetaDetail from '../../components/_common/MetaDetail';

import { buildContentAction } from '../../services/content/actions';


import './new-beers.scss';
import BeersGrid from '../../components/BeersGrid';
import Axios from 'axios';
import Event from '../../components/organisms/Event';
import EventsBanner from '../../components/EventsBanner';

class BeersPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			title: '',
			subheading: '',
			beerItems: []
		};
		this.getPageData();
	}
	
	async getPageData() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

		await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/Beer_Page.json?v=${Math.random()}`)
			.then(response => {
				this.parsePageData(response);
			});
	}

	parsePageData(response) {
		for (let field of response.data.contents[0].fields) {
			if (field.id === 'beerspagetitle') {
				this.setState({ title: field.value || 'Beers Menu' });
				continue;
			}
			else if (field.id === 'beerspagecopy') {
				this.setState({ subheading: field.value });
				continue;
			}
			else if (field.id ==='beerslisting') {
				this.fetchBeerItems(field.fields).then(response => { this.consolidateItems(response); });
			}
			continue;
		}
	}

	consolidateItems(stuff) {
		return Promise.all(stuff)
			.then((beerItems) => {
				this.setState({ beerItems });
			});
	}

	async fetchBeerItems(beerItemList) {
		let beerItemUrls = beerItemList.map((item) => item.id === 'beeritem' && item.value).filter(Boolean);

		let beerContent = beerItemUrls.map(async (url) => {
			let entry = await Axios.get(url);
			return entry.data.contents[0].fields;
		});

		return beerContent;
	}

	render() {
		const { title, subheading, beerItems } = this.state;
		const meta = {
			title: 'Beers',
			//TODO: Add new beers page description
			description: 'The Open Gate Brewery is the Guinness brewer\'s licence to experiment and dream in beer.',
			canonical: window.location.href
		};

		return (
			<div role="main" aria-label="Beers Page" className="BeersPage">
				<MetaDetail meta={meta} />
				<div className={'hero hero--active'}>
					<div className={'feature feature--active'}>
						<div className={'hero__container'}>
							<div className={'hero__background'} />
							<div className={'hero__heading-container'}>
								<div className={'hero__text-container'}>
									<h1 className={'hero__title'}>{title}</h1>
									<p className={'hero__subhead'}>{subheading}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<BeersGrid content={beerItems} />
			</div>
		);
	}
}

export default connect(
	() => ({}),
	{ buildContentAction }
)(BeersPage);



// WEBPACK FOOTER //
// ./src/pages/new-beers/index.js